import {
  READ_ACTION,
  TRANSFER_CONSULTANT,
  TRANSFER_CONSULTANT_LEAD,
  MANAGE_ACTION,
  USEFUL_LINKS,
  USEFUL_LINKS_FRANCHISE,
  PLANEJADORES_SELECTION_MENU,
  LEAD_PN_MENU,
  MY_TEAM_MENU,
  IMPORTER_CONSULTANT_MENU,
  USEFUL_LINKS_PREPOSTO,
  REALIZED_OKR,
  CERTIFICATE_MANAGEMENT_MENU,
  CHANGE_CONSULTANT_ROLE,
  COPILOT_AUDIT,
} from "@/constants/resources";

var navMenu = [
  {
    title: "Gestão de PNs",
    icon: "none",
    children: [
      {
        title: "Seleção de planejadores",
        route: "consultants-selection",
        icon: "UserPlusIcon",
        resource: PLANEJADORES_SELECTION_MENU,
        action: READ_ACTION,
      },
      {
        title: "Leads PNs",
        route: "potential-partners-list",
        icon: "UserCheckIcon",
        resource: LEAD_PN_MENU,
        action: READ_ACTION,
      },
      {
        title: "Minha equipe",
        route: "consultants-list",
        icon: "UsersIcon",
        resource: MY_TEAM_MENU,
        action: READ_ACTION,
      },
      {
        title: "Transferir PN",
        route: "consultant-transfer",
        icon: "RepeatIcon",
        resource: TRANSFER_CONSULTANT,
        action: MANAGE_ACTION,
      },
      {
        title: "Transferir Lead PN",
        route: "consultant-transfer-lead",
        icon: "RepeatIcon",
        resource: TRANSFER_CONSULTANT_LEAD,
        action: MANAGE_ACTION,
      },
      {
        title: "Promoção de nível de comissão",
        route: "consultant-role-promotions",
        icon: "TrendingUpIcon",
        resource: CHANGE_CONSULTANT_ROLE,
        action: MANAGE_ACTION,
      },
      {
        title: "Links úteis",
        href: "https://www.canva.com/design/DAFpGqyh39Y/8SyhG0FrRPyjv4zOUvdrQg/edit",
        icon: "ListIcon",
        resource: USEFUL_LINKS,
        action: READ_ACTION,
      },
      {
        title: "Links úteis franqueados",
        href: "https://www.canva.com/design/DAFrozXp17M/nfNsZaC0ALkDHXgwo_4GiQ/edit",
        icon: "BookIcon",
        resource: USEFUL_LINKS_FRANCHISE,
        action: READ_ACTION,
      },
      {
        title: "Links úteis Prepostos",
        href: "https://www.canva.com/design/DAG0eFQjJMk/DtrpFYnvsEEgCZgBHZxiUQ/edit",
        icon: "ListIcon",
        resource: USEFUL_LINKS_PREPOSTO,
        action: READ_ACTION,
      },
      {
        title: "Gestão de certificados",
        route: "certificate-management",
        icon: "AwardIcon",
        resource: CERTIFICATE_MANAGEMENT_MENU,
        action: MANAGE_ACTION,
      },
      {
        title: "Onboarding pendente",
        route: "pns-pending-onboarding",
        icon: "AlertCircleIcon",
        resource: MY_TEAM_MENU,
        action: READ_ACTION,
      },
      {
        title: "Auditoria do Copiloto",
        route: "copilot-audit",
        icon: "ActivityIcon",
        resource: COPILOT_AUDIT,
        action: READ_ACTION,
      },
      {
        title: "Importações",
        route: "imports",
        icon: "UploadIcon",
        resource: IMPORTER_CONSULTANT_MENU,
        action: READ_ACTION,
      },
    ].filter(Boolean),
  },
];

export default navMenu;
